/**
 * Web component: Influencer hero teaser (influencer-hero-teaser)
 * -----------------------------------------------------------------------------
 * Hero teaser section used on the influencer pages.
 *
 */
import './influencer-hero-teaser.scss';
import '~async/read-more-less/read-more-less.scss';
import { handleCopy, updateTeaser } from '~/helpers/teasers';

import { vueReady } from '~/core/runners';

/**
 * DOM selectors.
 */
const selectors = {
  copyButton: '[js-influencer-hero-teaser="copy-button"]',
  tooltip: '[js-influencer-hero-teaser="tooltip"]',
  promoText: '[js-influencer-hero-teaser="promoText"]',
};

/**
 * Create new <influencer-hero-teaser> custom element.
 */
class InfluencerHeroTeaser extends HTMLElement {
  data(component) {
    return {
      selectors: {
        copyButton: component.querySelector(selectors.copyButton),
        tooltip: component.querySelector(selectors.tooltip),
        promoText: component.querySelector(selectors.promoText),
      },
    };
  }

  constructor() {
    super();
    this.$data = this.data(this);
    this.teaserUpdated = false;

    // for initial load, read campaign state from local storage and update
    // teaser if necessary
    const { copyButton } = this.$data.selectors;
    if (copyButton) {
      const discountCampaigns = JSON.parse(
        localStorage.getItem('discount-campaigns'),
      );
      updateTeaser.call(this, discountCampaigns);

      // listen to campaign changes, update teaser content
      cnvs.EventBus.listen('discount-campaign', (campaigns) => {
        updateTeaser.call(this, campaigns);
      });
    }
  }

  /**
   * Lifecycle hook - component is attached to DOM.
   */
  connectedCallback() {
    this.$data = Object.keys(this.$data).length ? this.$data : this.data(this);

    const { copyButton } = this.$data.selectors;

    if (!copyButton) {
      return;
    }

    copyButton.addEventListener('click', (event) =>
      handleCopy(event, selectors.tooltip),
    );
  }
}

/**
 * Define web component on Vue initialisation.
 */
vueReady(() => {
  if (customElements.get('influencer-hero-teaser')) {
    return;
  }

  customElements.define('influencer-hero-teaser', InfluencerHeroTeaser);
});
